export const PRODUCTS = [
  // Industrial Oils
  {
    id: 1,
    category: "Industrial Oils",
    categorySlug: "industrial-oils",
    navText: " Industrial Oils",
    slug: "alessa-16",
    title: "ALESSA 16",
    brand: "ALESSA",
    img: "/assets/img/products_image/Industrial_Oils/Alessa/Alessa16/Alessa.jpg",
    desc: "ALESSA - 16 meets all needs and expectations of modern machining. This conventional type oil has very good flushing and cooling properties, which is suitable for operations like Grinding, Drilling, Milling and Turning. It forms a spontaneous white semi translucent emulsion. Due to good flushing properties the chip carry is fantastic, giving specified finish. It is equipped with effective Anti-rusting compounds to protect the machined components form rusting for 2-3 shifts. It's unique extreme pressure additives and fungicides dosage; make it all-purpose coolant with moderate bath life and no bad smell even when bath is unused for one day.",

    whatsappText: "Hello, I want details about ALESSA 16",
  },
  {
    id: 2,
    category: "Industrial Oils",
    categorySlug: "industrial-oils",
    navText: " Industrial Oils",
    slug: "alessa-super-30",
    title: "ALESSA SUPER 30 (Semi Synthetic Cutting Oil)",
    brand: "ALESSA",
    img: "/assets/img/products_image/Industrial_Oils/Alessa/Alessa30/Alessa.jpg",
    desc: "ALESSA SUPER 30 meets all needs and expectations of modern machining. This semi-synthetic oil has very Good flushing and cooling properties, which is suitable for operations like Grinding, Drilling, Milling and Turning. Due to good flushing properties the chip carry is fantastic, giving good finish. Unique extreme pressure additives and fungicides make it all-purpose coolant with longer bath life and no bad smell.",

    whatsappText: "Hello, I want details about ALESSA SUPER 30",
  },
  {
    id: 3,
    category: "Industrial Oils",
    categorySlug: "industrial-oils",
    navText: " Industrial Oils",
    slug: "alessa-super-90-semi-synthetic",
    title: "ALESSA SUPER 90 (Semi Synthetic Cutting Oil)",
    brand: "ALESSA",
    img: "/assets/img/products_image/Industrial_Oils/Alessa/alessa90/alessa.jpg",
    desc: "ALESSA SUPER 90 is one of our premium products, which meet all needs and expectations of modern machining. This semi-synthetic oil has very good flushing and cooling properties, which renders suitable for operations like, High Speed Grinding, CBN Grinding, Drilling, Milling, Turning and Tapping. It gives best visibility of the operation due to its translucent emulsion. Due to good flushing properties the chip carry is fantastic, giving mirror finish. It is equipped with unique extreme pressure additives and fungicides that make it all-purpose coolant with good tool and bath life",

    whatsappText: "Hello, I want details about ALESSA SUPER 90",
  },
  {
    id: 4,
    category: "Industrial Oils",
    categorySlug: "industrial-oils",
    navText: " Industrial Oils",
    slug: "alessa-super-9000",
    title: "ALESSA SUPER 9000 (Premium Semi Syntetic Cutting Oil)",
    brand: "ALESSA",
    img: "/assets/img/products_image/Industrial_Oils/Alessa/Alessa9000/alessa.jpg",
    desc: "Multi Metal ALESSA - 9000 is one of our premium products, which meets all needs and expectations of modern day precision, speed and cost effective machining. This semi-synthetic oil is blended with highly refined and specially treated base oils and synthetic esters which provides extremely oxidative and thermally stable oil films during operations. It has very good flushing and cooling properties, which renders suitable for operations like, High Speed Grinding, CBN Grinding, Drilling, Milling, Turning and Tapping on CNC's and multi spindle machines. It gives best visibility of the operation due to its translucent emulsion. Due to good flushing properties the chip carry is fantastic, giving mirror finish. It is equipped with unique extreme pressure additives and fungicides that make it all-purpose coolant with value for money, tool and bath life",

    whatsappText: "Hello, I want details about ALESSA SUPER 9000",
  },
  {
    id: 5,
    category: "Industrial Oils",
    categorySlug: "industrial-oils",
    navText: " Industrial Oils",
    slug: "alessa-synth-kut-90",
    title: "ALESSA SYNTH KUT - 90 (Synthetic Cutting Oil)",
    brand: "ALESSA",
    img: "/assets/img/products_image/Industrial_Oils/Alessa/ALESSASYNTHKUTSUPER90/alessa.jpg",
    desc: "Water Soluble Synthetic Metal Working Fluid ALESSA SYNTH KUT -90 is one of our premium products, which meets all needs and expectations of modern machining. This synthetic oil has very good flushing and cooling properties, which renders suitable for operations like, High Speed Grinding, CBN Grinding, moderate Drilling, Milling, Turning on CNC's machines. It gives best visibility of the operation due to its transparent emulsion. Due to good flushing properties the chip carry is fantastic, giving specified finish. The synthetic nature of the coolant helps in settling the grinding particles to the bottom of the coolant tank. It is equipped with unique anti rusting additives and biocides that makes it a good grinding coolant with good tool and bath life.",

    whatsappText: "Hello, I want details about ALESSA SYNTH KUT 90",
  },
  {
    id: 6,
    category: "Industrial Oils",
    categorySlug: "industrial-oils",
    navText: " Industrial Oils",
    slug: "alessa-55",
    title: "ALESSA-55 (Fully Synth Cutting & Grinding fluid / Leak testing)",
    brand: "ALESSA",
    img: "/assets/img/products_image/Industrial_Oils/Alessa/ALESSA55(SyntheticWaterSoluble)/alessa.jpg",
    desc: "grinding oil. It is transparent, fluorescent green colored solution. It mixes quickly with water, hard or soft, in any proportion. It does not contain any oily sticking material. Excellent detergency keeps grinding wheel clean for free cutting, No pit marks and chatter marks on ground surface. Results in specified ground finish, Tool as well as machine remains clean all the time, Being purely synthetic in nature, longer life of bath. No offensive odor of used bath, due to powerful biocides in the oil, Environmentally and Operator Friendly, Job can be clearly observed with greater ease, while in operation, Good protection against rusting, up to 3-4 days, It can be used very efficiently for leakage testing baths due to its clear fluorescent micro emulsion.",

    whatsappText: "Hello, I want details about ALESSA-55",
  },
  {
    id: 7,
    category: "Industrial Oils",
    categorySlug: "industrial-oils",
    navText: " Industrial Oils",
    slug: "alessa-1872",
    title:
      "ALESSA-1872 (Water-Soluble Synthetic Metal Working Fluid for Aluminium Machining)",
    brand: "ALESSA",
    img: "/assets/img/products_image/Industrial_Oils/Alessa/ALESSA1872/alessa.jpg",
    desc: "ALESSA-1872 is a high-performance, semi synthetic coolant specifically formulated for aluminium machining in high-speed and multi-spindle operations. It offers excellent flushing action, superior surface finish, and extended tool life. Its biodegradable and low-toxicity formulation ensures operator safety and environmental compliance, while effective biocides and anti-oxidants deliver long bath life, prevent aluminium oxidation, and reduce machine downtime-boosting overall productivity.",

    whatsappText: "Hello, I want details about ALESSA 1872",
  },
  {
    id: 8,
    category: "Industrial Oils",
    categorySlug: "industrial-oils",
    navText: " Industrial Oils",
    slug: "fine-kut-40",
    title: "FINE KUT 40",
    brand: "FINE KUT",
    img: "/assets/img/products_image/Industrial_Oils/finekut.jpg",
    desc: "A premium quality emulsificable cutting oil suitable for all types of machining operations to offer excellent cooling and tool life. Special additives and rust inhibitors are added to ensure excellent performance and to minimize bacterial growth in the emulsion.Diluted in water at concentration ranging between 3 to 10 %, Provides excellent cooling, mild lubricity, rust prevention. Performs upto 250 ppm.",

    whatsappText: "Hello, I want details about FINE KUT 40",
  },
  {
    id: 9,
    category: "Industrial Oils",
    categorySlug: "industrial-oils",
    navText: " Industrial Oils",
    slug: "fine-kut-ss-4000",
    title: "FINE KUT SS 4000",
    brand: "FINE KUT",
    img: "/assets/img/products_image/Industrial_Oils/finekut.jpg",
    desc: "A semi synthetic cutting fluid designed to give more longer emulsion life than normal soluble cutting fluid. It mixes readily with water r to to provide excellent lubrication and corossion protection. It can also be used for machining of aluminum and alloys. It has better operational performance and is operator friendly.",

    whatsappText: "Hello, I want details about FINE KUT SS 4000",
  },
  {
    id: 10,
    category: "Industrial Oils",
    categorySlug: "industrial-oils",
    navText: " Industrial Oils",
    slug: "fine-kut-hw",
    title: "FINE KUT HW",
    brand: "FINE KUT",
    img: "/assets/img/products_image/Industrial_Oils/finekut.jpg",
    desc: "A premium quality water soluble cutting oil suitable for heavy machining operations offering excellent tool life & sump life. This Cutting oil is formulated to achieve high performance in hard water upto 650 to 700 ppm.",

    whatsappText: "Hello, I want details about FINE KUT HW",
  },
  {
    id: 11,
    category: "Industrial Oils",
    categorySlug: "industrial-oils",
    navText: " Industrial Oils",
    slug: "fine-kut-ss-8000",
    title: "FINE KUT SS 8000",
    brand: "FINE KUT",
    img: "/assets/img/products_image/Industrial_Oils/finekut.jpg",
    desc: "This is a robust semi synthetic fluid for multi metal operations for new age advanced machines. No foaming at high pressures & performs up to 1000 PPM water hardness.",

    whatsappText: "Hello, I want details about FINE KUT SS 8000",
  },
  {
    id: 12,
    category: "Industrial Oils",
    categorySlug: "industrial-oils",
    navText: " Industrial Oils",
    slug: "fine-kut-6000",
    title: "FINE KUT 6000",
    brand: "FINE KUT",
    img: "/assets/img/products_image/Industrial_Oils/finekut.jpg",
    desc: "This is a super heavy duty water soluble cutting oil designed to achieve the best performance in hard water upto 750 PPM. It is suitable for all metals and all types of machining operations.",

    whatsappText: "Hello, I want details about FINE KUT 6000",
  },
  {
    id: 13,
    category: "Industrial Oils",
    categorySlug: "industrial-oils",
    navText: " Industrial Oils",
    slug: "synthofine-70",
    title: "SYNTHOFINE 70",
    brand: "FINE KUT",
    img: "/assets/img/products_image/syntho fine.webp",
    desc: "Is a fully synthetic cutting oil developed specially for high speed fine and surface surface grinding. grinding. It It can ca be used by diluting 3-5% in Soft water.",

    whatsappText: "Hello, I want details about SYNTHOFINE 70",
  },
  // Straight Cutting Oils
  {
    id: 14,
    category: "Straight Cutting Oils",
    categorySlug: "straight-cutting-oils",
    navText: "Straight Cutting Oils",
    slug: "fine-kut-14",
    title: "FINE KUT 14",
    img: "/assets/img/products_image/St_cutting_oil/St_Cutting_Oil.jpg",
    desc: "A low viscous and light coloured oil compatible with all ferrous and non ferrous metals without causing any staining. This product contains additives which impart oiliness and is generally used for all types of cutting, turning operations.",

    whatsappText: "Hello, I want details about FINE KUT 14",
  },
  {
    id: 15,
    category: "Straight Cutting Oils",
    categorySlug: "straight-cutting-oils",
    navText: "Straight Cutting Oils",
    slug: "fine-kut-23",
    title: "FINE KUT 23",
    img: "/assets/img/products_image/St_cutting_oil/St_Cutting_Oil.jpg",
    desc: "Suitable for high-speed automatic machine tools and may also be used as a general purpose machine tool lubricant. It has excellent wetting and flushing properties which makes it long lasting. It is chlorine and sulphur free in nature makes it an easily disposable.",

    whatsappText: "Hello, I want details about FINE KUT 23",
  },
  {
    id: 16,
    category: "Straight Cutting Oils",
    categorySlug: "straight-cutting-oils",
    navText: "Straight Cutting Oils",
    slug: "fine-kut-55",
    title: "FINE KUT 55",
    img: "/assets/img/products_image/St_cutting_oil/St_Cutting_Oil.jpg",
    desc: "A medium viscous dark coloured oil used for all types of ferrous and non ferrous metals in different types of turning and gear grinding/hobbing operations.",

    whatsappText: "Hello, I want details about FINE KUT 55",
  },
  {
    id: 17,
    category: "Straight Cutting Oils",
    categorySlug: "straight-cutting-oils",
    navText: "Straight Cutting Oils",
    slug: "fine-kut-56",
    title: "FINE KUT 56",
    img: "/assets/img/products_image/St_cutting_oil/St_Cutting_Oil.jpg",
    desc: "Very similar to FINE KUT 55 but more viscous and with a better additive pack. It delivers a better finished product and is used for all types of grinding, broaching, turning operations.",

    whatsappText: "Hello, I want details about FINE KUT 56",
  },
  {
    id: 18,
    category: "Straight Cutting Oils",
    categorySlug: "straight-cutting-oils",
    navText: "Straight Cutting Oils",
    slug: "fine-hone-7",
    title: "FINE HONE 7",
    img: "/assets/img/products_image/St_cutting_oil/St_Cutting_Oil.jpg",
    desc: "FINE HONE 7 is a premium low-viscosity honing oil designed for superior lubrication, cooling, anddebris removal in precision honing. It extends honing stone life, delivers excellent surface finish, and ensures consistent, efficient performance for high-quality machining operations.",

    whatsappText: "Hello, I want details about FINE HONE 7",
  },
  {
    id: 19,
    category: "Straight Cutting Oils",
    categorySlug: "straight-cutting-oils",
    navText: "Straight Cutting Oils",
    slug: "meta-kut-40",
    title: "META KUT 40",
    img: "/assets/img/products_image/St_cutting_oil/St_Cutting_Oil.jpg",
    desc: "Neat Type Metal Working Fluid It is specially designed to avoid varieties of oils for different operations and metals, ferrous and nonferrous. Meta kut-40 is enriched with effective and unique extreme pressure additives derived from Sulphurized fats and effective tension depressants, which ensure direct contact of oil with the cutting edge. The effectively designed and formulated extreme pressure additives provide oil film of high strength, which withstands the heavy load of boundary lubrications. It can serve all the ations such as gun drilling, gear grinding on automats and moderate feed rates for gear Hobbing and broaching etc. However it's not suitable for honing operations.",

    whatsappText: "Hello, I want details about META KUT 40",
  },
  {
    id: 20,
    category: "Straight Cutting Oils",
    categorySlug: "straight-cutting-oils",
    navText: "Straight Cutting Oils",
    slug: "meta-kut-70",
    title: "META KUT 70 (neat cutting oil)",
    img: "/assets/img/products_image/St_cutting_oil/St_Cutting_Oil.jpg",
    desc: "Meta kut-70 is enriched with highly effective extreme pressure additives derived from Sulphurized fats and surface tension depressants, which ensure direct contact of oil with the cutting edge Effectively designed and formulated extreme pressure additives provide oil film of high strength, which withstands the heavy load of boundary lubrications and friction. It subsequently increases broach life at least two folds compared against any other brand broaching oil. Higher broach life provides greater productivity and lowered production cost. Metakut-70 can be used on all ferrous metals and alloys. It can be also used for other stringent operation like Gear cutting, Gear Hobbing, Thread rolling with same effect.",

    whatsappText: "Hello, I want details about META KUT 70 (neat cutting oil)",
  },
  {
    id: 21,
    category: "Straight Cutting Oils",
    categorySlug: "straight-cutting-oils",
    navText: "Straight Cutting Oils",
    slug: "fine-grind-5",
    title: "FINE GRIND 5",
    img: "/assets/img/products_image/St_cutting_oil/St_Cutting_Oil.jpg",
    desc: "A premium non-water-miscible straight oil, specially formulated for high-precision grinding of carbide, steel, and alloy components. It offers superior lubricity, effective cooling, reduced wheel wear, and excellent surface finish. Ideal for surface, cylindrical, centerless, and creep-feed grinding operations.",

    whatsappText: "Hello, I want details about FINE GRIND 5",
  },
  {
    id: 22,
    category: "Straight Cutting Oils",
    categorySlug: "straight-cutting-oils",
    navText: "Straight Cutting Oils",
    slug: "fine-broach-22",
    title: "FINE BROACH 22",
    img: "/assets/img/products_image/St_cutting_oil/St_Cutting_Oil.jpg",
    desc: "Broaching Oil is a high-performance cutting oil specially formulated for broaching operations on ferrous and non-ferrous metals. It offers excellent lubricity, superior EP (extreme pressure) performance, and effective cooling to reduce tool wear and improve surface finish. Ideal for precision machining applications, it ensures clean, accurate cuts and extended tool life.",

    whatsappText: "Hello, I want details about FINE BROACH 22",
  },
  // Mist Oils
  {
    id: 23,
    category: "Mist Oil (Minimum Quantity Lubrication Oil)",
    categorySlug: "mist-oils",
    navText: "Mist Oils",
    slug: "fine-mist-30",
    title: "FINE MIST 30 (SYNTHETIC ESTER BASE MIST OIL)",
    img: "/assets/img/products_image/Industrial_Oils/Alessa/MIST70&30/mist.jpg",
    desc: "NEAT TYPE SPRAYING OR MISTING METAL WORKING FLUID FINEMIST 30 is special grade, formulated for operations like milling, drilling wherein metal working fluid is used by spraying or misting method. It is enriched with non-ionic extreme pressure and boundary lubricants which are non-staining for copper brass and its alloys. The unique and special additives help to deliver high performance in minimum oil layer thickness.",

    whatsappText: "Hello, I want details about FINE MIST 30",
  },
  {
    id: 24,
    category: "Mist Oil (Minimum Quantity Lubrication Oil)",
    categorySlug: "mist-oils",
    navText: "Mist Oils",
    slug: "fine-mist-46-68",
    title: "FINE MIST 46 & 68 (MINERAL ESTER BASE MIST OIL)",
    img: "/assets/img/products_image/Industrial_Oils/Alessa/MIST70&30/mist.jpg",
    desc: "Premium mineral-based oils fortified with high-performance additives and esters, specifically developed for mist lubrication in high-speed machining and pneumatic tools. These oils ensure fine mist generation, superior wear protection, and clean, residue-free operation. Available in ISO VG 46 and 68 viscosity grades.",

    whatsappText: "Hello, I want details about FINE MIST 46 & 68",
  },
  // Rust Preventive Oils
  {
    id: 25,
    category: "Rust Preventive Oils",
    categorySlug: "rust-preventive-oils",
    navText: "Rust Preventive Oils",
    slug: "anti-rust-oil-dw-802",
    title: "ANTI RUST OIL DW 802",
    img: "/assets/img/products_image/Rust_preventive_oil/Anti_Rust_Oil.jpg",
    desc: "Rust preventives are added with water and moisture displacing additives that replace wateror moisture in place of the additive and forms thin film overit. They are applied by dipping or spraying, they are most suitable in humid atmosphere. We cater to all types of RPO's depending upon users application.",

    whatsappText: "Hello, I want details about ANTI RUST OIL DW 802",
  },
  {
    id: 26,
    category: "Rust Preventive Oils",
    categorySlug: "rust-preventive-oils",
    navText: "Rust Preventive Oils",
    slug: "anti-rust-oil-dw-902",
    title: "ANTI RUST OIL DW 902",
    img: "/assets/img/products_image/Rust_preventive_oil/Anti_Rust_Oil.jpg",
    desc: "Is the best solvent based rust preventive oil developed by our R & D team. It succesfully passes a salt spray test of 72 hours which goes beyond 100 hours. It coats the job by a thin and soft film of 4-5 microns which in turn provides a rust protection of one vear in indoor conditions and 4-6 months in outdoor conditions (when covered/packed).",

    whatsappText: "Hello, I want details about ANTI RUST OIL DW 902",
  },
  {
    id: 27,
    category: "Rust Preventive Oils",
    categorySlug: "rust-preventive-oils",
    navText: "Rust Preventive Oils",
    slug: "anti-rust-oil-lcx-56",
    title: "ANTI RUST OIL LCX 56",
    img: "/assets/img/products_image/Rust_preventive_oil/Anti_Rust_Oil.jpg",
    desc: "Is an oil based rust preventive oil of medium viscosity. Appearance of the product is almost transparent. It is enough to protect the job for one month from oxidation. It passes a salt spray of 48 hours.",

    whatsappText: "Hello, I want details about ANTI RUST OIL LCX 56",
  },
  {
    id: 28,
    category: "Rust Preventive Oils",
    categorySlug: "rust-preventive-oils",
    navText: "Rust Preventive Oils",
    slug: "fine-seal",
    title: "FINE SEAL",
    img: "/assets/img/products_image/Rust_preventive_oil/Anti_Rust_Oil.jpg",
    desc: "This is a golden vellow rust preventive containing resins, additives & solvent. It forms a film of about 5 microns on the component giving a minimum rust protection for 10-12 Months. It can be easily removed with a solvent like Toluene / MTO.",

    whatsappText: "Hello, I want details about FINE SEAL",
  },
  {
    id: 29,
    category: "Rust Preventive Oils",
    categorySlug: "rust-preventive-oils",
    navText: "Rust Preventive Oils",
    slug: "anti-rust-oil-274",
    title: "ANTI RUST OIL 274",
    img: "/assets/img/products_image/Rust_preventive_oil/Anti_Rust_Oil.jpg",
    desc: "ANTI RUST OIL 274 is a premium oil-based rust preventive fluid designed to provide effective corrosion protection for metal parts during storage and transit. Effectively displacing moisture from metal surfaces and forming a uniform, oily protective film that prevents rust formation. This product is ideal for use after metalworking operations such as machining, grinding, or washing, especially when water or coolant residue is present.",

    whatsappText: "Hello, I want details about ANTI RUST OIL 274",
  },
  // Rust Removers
  {
    id: 30,
    category: "Cleaning Chemicals and Rust Removers",
    categorySlug: "cleaning-chemicals-rust-removers",
    navText: "Rust Removers",
    slug: "fine-clean",
    title: "FINE CLEAN",
    img: "/assets/img/products_image/Rust_Remover/Anti_Rust_Oil.jpg",
    desc: "It is a low aromatic solvent base cleaner used to clean jobs after machining & to remove dirt, chips & oil. It dries off quickly & later rust preventive oil can be applied.",

    whatsappText: "Hello, I want details about FINE CLEAN",
  },
  {
    id: 31,
    category: "Cleaning Chemicals and Rust Removers",
    categorySlug: "cleaning-chemicals-rust-removers",
    navText: "Rust Removers",
    slug: "fine-rust-o-clean",
    title: "FINE RUST O CLEAN",
    img: "/assets/img/products_image/Rust_Remover/Anti_Rust_Oil.jpg",
    desc: "Is an ambient temperature, non nitrated spray cleaner cum water based rust preventive oil with short term rust protection. It works very well in all stages of multi stage washers. It is a non foaming cleaner which works well in moderately hard water.",

    whatsappText: "Hello, I want details about FINE RUST O CLEAN",
  },
  {
    id: 32,
    category: "Cleaning Chemicals and Rust Removers",
    categorySlug: "cleaning-chemicals-rust-removers",
    navText: "Rust Removers",
    slug: "fine-rust-o-clean-141",
    title: "RUST O CLEAN 141",
    img: "/assets/img/products_image/Rust_Remover/Anti_Rust_Oil.jpg",
    desc: "This is a water based rust remover, it can be diluted with DM water by 1:15 or 1:20 depending upon severity of rust on the job. Later the Job can be immersed in solution for 30-40 seconds to get rid of the rust on it.",

    whatsappText: "Hello, I want details about FINE RUST O CLEAN",
  },
  {
    id: 33,
    category: "Cleaning Chemicals and Rust Removers",
    categorySlug: "cleaning-chemicals-rust-removers",
    navText: "Rust Removers",
    slug: "fine-clean-1240-water-base-cleaner",
    title: "FINE CLEAN - 1240 (Water Base Cleaner)",
    img: "/assets/img/products_image/Rust_Remover/Anti_Rust_Oil.jpg",
    desc: "Water Soluble Metal Washing Solution It can be used for ferrous and nonferrous metal. It can be used at ambient can temperature for cold washing and even suitable for hot washing at operational temperature 40 to 65 °c. Operational solution pressure may vary from 2-20 Bar depending on the Geometry of the joband Millipore values required. (In some cases up to 200 Bar pressure for specific nozzle n time) Dilution ratio: 1:20 for Cast iron and 1:30 for Aluminum",

    whatsappText:
      "Hello, I want details about FINE CLEAN - 1240 (Water Base Cleaner)",
  },
  // Hydraulic Oils
  {
    id: 34,
    category: "Hydraulic Oils",
    categorySlug: "hydraulic-oils",
    navText: "Hydraulic Oils",
    slug: "fine-lube",
    title: "FINE LUBE",
    img: "/assets/img/products_image/Hydraulic_Oil/Hydraulic_Oil2.jpg",
    desc: "FINE LUBE is premium hydraulic oil packed with high performance additives, outstanding lubrication characteristics and excellent thermal stability. Their operating ranges are between -15 deg to +60 deg. They are recommended for electro hydraulic controlled systems.",
    variants: [
      "Fine Lube 32",
      "Fine Lube 46",
      "Fine Lube 68",
      "Fine Lube 100",
      "Fine Lube 150",
      "Fine Lube 220",
      "Fine Lube 320",
      "Fine Lube 460",
    ],

    whatsappText: "Hello, I want details about FINE LUBE",
  },
  {
    id: 35,
    category: "Hydraulic Oils",
    categorySlug: "hydraulic-oils",
    navText: "Hydraulic Oils",
    slug: "fine-lube-hlp",
    title: "FINE LUBE (HLP)",
    img: "/assets/img/products_image/Hydraulic_Oil/Hydraulic_Oil1.jpg",
    desc: "FINE LUBE (HLP) is a high-performance HLP hydraulic oil formulated with superior quality base oils and fortifie advanced additive technology. It offers outstanding lubrication performance, exceptional thermal and oxidative excellent wear protection, making it ideal for demanding industrial applications.",
    variants: ["HLP 32", "HLP 46", "HLP 68", "HLP 100"],
    specs: [
      "Superior anti-wear and anti-oxidation properties",
      "Excellent protection against rust and corrosion",
      "High thermal stability for extended oil life",
      "Outstanding demulsibility and filterability",
    ],

    whatsappText: "Hello, I want details about FINE LUBE (HLP)",
  },
  // Turbine Oils
  {
    id: 36,
    category: "Turbine Oils",
    categorySlug: "turbine-oils",
    navText: "Turbine Oils",
    slug: "turbine-oils",
    title: "TURBINE OILS",
    img: "/assets/img/products_image/Turbine_Oil/Turbine_oil.jpg",
    desc: "They are used to for lubrication of steam / gas & hydraulic turbines. They are fortified with premium quality base oils, additives, corrosion inhibitors. They are premium quality lubricating oils designed for long service hours.",
    variants: ["Fine Train 32", "Fine Train 46", "Fine Train 68"],

    whatsappText: "Hello, I want details about TURBINE OILS",
  },
  // Compressor Oils
  {
    id: 37,
    category: "Compressor Oils",
    categorySlug: "compressor-oils",
    navText: "Compressor Oils",
    slug: "compressor-oils",
    title: "COMPRESSOR OILS",
    img: "/assets/img/products_image/Compresoor_oil/Oil_Test_Procedure.webp",
    desc: "These oils are specially developed from high viscosity index Group 2 base stocks for long service hours. They have good oxidation stability, anti-rust & anti-foaming additives which can sustain high pressure.",
    variants: [
      "Fine Comp 32",
      "Fine Comp 46",
      "Fine Comp 68",
      "Fine Comp 100",
      "Fine Comp 150",
      "Fine Comp 220",
      "Fine Comp 320",
      "Fine Comp 460",
    ],

    whatsappText: "Hello, I want details about Compressor Oils",
  },
  // Gear Oils
  {
    id: 38,
    category: "Gear Oils",
    categorySlug: "gear-oils",
    navText: "Gear Oils",
    slug: "gear-oils",
    title: "GEAR OILS",
    img: "/assets/img/products_image/Gear_Oil/Gear_OIl.jpg",
    desc: "FINE GEAR contains extreme pressure additives, anti-foam, anti-rust and anti-oxidation agents application areas are for all heavy duty enclosed gear drives with splash or circulation lubrication systems.",
    variants: [
      "Fine Gear EP 100",
      "Fine Gear EP 150",
      "Fine Gear EP 220",
      "Fine Gear EP 320",
      "Fine Gear EP 460",
      "Fine Gear EP 680",
    ],

    whatsappText: "Hello, I want details about Gear Oils",
  },
  // Spindle Oils
  {
    id: 39,
    category: "Spindle Oils",
    categorySlug: "spindle-oils",
    navText: "Spindle Oils",
    slug: "spindle-oils",
    title: "SPINDLE OILS",
    img: "/assets/img/products_image/Fine Kut (St. Cutting Oil)1.jpeg",
    desc: "FINE SPIN spindle oils are formulated from selected high quality, low viscosity base stocks and additives that give good resistance to oxidation, foaming at high pressures. They are designed for lubrication of high speed spindles in machines.",
    variants: ["Fine Spin 2", "Fine Spin 10", "Fine Spin 12", "Fine Spin 22"],

    whatsappText: "Hello, I want details about Spindle Oils",
  },
  // Quenching Oils
  {
    id: 40,
    category: "Quenching oils",
    categorySlug: "quenching-oils",
    navText: "Quenching oils",
    slug: "quenching-oils",
    title: "QUENCHING OILS",
    img: "/assets/img/products_image/Quenching_oil/Quenching_Oil.jpg",
    desc: "Quenching oils are designed to work as a fluid media in quenching operations. They are mostly blended in group 2 base stocks for faster and safe quenching. Reduced consumption of oil and better job finish and faster cooling rate.",
    variants: ["Fine Quench 39", "Fine Quench 40", "Fine Quench 42"],

    whatsappText: "Hello, I want details about Quenching Oils",
  },
  // Heat Transfer Fluids
  {
    id: 41,
    category: "Heat Transfer Fluids",
    categorySlug: "heat-transfer-fluids",
    navText: "Heat Transfer Fluids",
    slug: "heat-transfer-fluids",
    title: "HEAT TRANSFER FLUIDS (THERMIC OILS)",
    img: "/assets/img/products_image/Heat_Transfer_Fluid/Thermic_oil.png",
    desc: "A liquid that transfers heat from one component to another is called heat transfer fluid. These fluids are used in processes where heating is required is required to maintain a particular temperature. They are made from carefully selected high viscosity index base stocks.",
    variants: [
      "Fine Therm 500 (Performs up to 500 Deg. F)",
      "Fine Therm 600 (Performs up to 600 Deg. F)",
      "Fine Therm 650 (Synthetic Base, Performs up to 650 Deg. F)",
    ],

    whatsappText: "Hello, I want details about Quenching Oils",
  },
  // EDM Oils
  {
    id: 42,
    category: "EDM OILS",
    categorySlug: "edm-oils",
    navText: "EDM Oils",
    slug: "edm-oils",
    title: "EDM OILS (SPARK EROSION OILS)",
    img: "/assets/img/products_image/Edm_Oil/Edm_Oil.jpeg",
    desc: "FINE SPARK 110 is a universal EDM oil that shows great results in fine and rough machining. These are excellent for flushing with high di-electric strength. They work with all standard electrode materials like copper or graphite.",

    whatsappText: "Hello, I want details about EDM Oils",
  },
  // MPI Oils
  {
    id: 43,
    category: "MPI OILS",
    categorySlug: "mpi-oils",
    navText: "MPI Oils",
    slug: "mpi-oils",
    title: "MPI OIL (for crack detection)",
    img: "/assets/img/products_image/Fine Kut (St. Cutting Oil)1.jpeg",
    desc: "High-quality Magnetic Particle Inspection Oil with excellent clarity, stable suspension, good fluorescence visibility, and superior corrosion protection. ction. Specially Specially formulated formulated to to ensure ensure reliable flaw detection n in in industrial in NDT applications.",

    whatsappText: "Hello, I want details about MPI Oils",
  },
  // General Purpose Lubrication Oils
  {
    id: 44,
    category: "General Purpose Lubrication",
    categorySlug: "general-purpose-lubrication-oils",
    navText: "General Purpose Lubrication",
    slug: "fine-lube-40",
    title: "FINE LUBE 40",
    img: "/assets/img/products_image/General_purpose_lubricants/Fine_Lube_40.jpg",
    desc: "FINE LUBE 40 is a general purpose slideway lubrication oil. They are manufactured from superior quality base stocks and fortified with additives like anti-wear and anti-rust. They impart good oiliness and film s trength to improve lubrication.",

    whatsappText: "Hello, I want details about FINE LUBE 40",
  },
  // Tapping Oils - Fine Tap
  {
    id: 45,
    category: "Tapping Oils - Fine Tap",
    categorySlug: "tapping-oils-fine-tap",
    navText: "Tapping Oils - Fine Tap",
    slug: "fine-tap-40",
    title: "Premium High-Viscosity Tapping Oil",
    img: "/assets/img/products_image/Fine Kut (St. Cutting Oil)1.jpeg",
    desc: "Fine Tap is a dark red, heavy-duty tapping oil formulated from vegetable oils and advanced extreme pressure (EP) additives. Engineered to extend tap life, it effectively prevents chip welding, tap seizing, and overheating. Suitable for , tap seizing, application by brush or dipping, Fine Tap ensures exceptional performance in demanding tapping operations.",
    variants: ["Fine Tap 56", "Fine Tap 5000"],

    whatsappText: "Hello, I want details about FINE TAP 40",
  },
  {
    id: 46,
    category: "Efficient, Clean, and Easy-to-Remove Lubricant",
    categorySlug: "tapping-oils-fine-tap",
    navText: "Tapping Oils - Fine Tap",
    slug: "water-washable-tapping-oil",
    title: "WATER WASHABLE TAPPING OIL",
    img: "/assets/img/products_image/Fine Kut (St. Cutting Oil)1.jpeg",
    desc: "Water Washable Tapping Oil is specially formulated for tapping operations requiring easy removal with water-based cleaning systems. It delivers excellent lubrication and cooling, minimizes tool wear, and prevents chip welding, while ensuring residues are easily washable. Ideal for precision machining applications where cleanliness and efficient post-process cleanup are critical.",
    variants: ["Fine Tap 100H", "Fine Tap 200H"],

    whatsappText: "Hello, I want details about WATER WASHABLE TAPPING OIL",
  },
  // Drawing Oils. Punching Oils. Rolling Oil
  {
    id: 47,
    category: "Drawing Oils. Punching Oils. Rolling Oil",
    categorySlug: "drawing-oils-punching-oils-rolling-oil",
    navText: "Punching Oils. Rolling Oil",
    slug: "fine-draw-ms",
    title: "FINE DRAW MS",
    img: "/assets/img/products_image/Fine Kut (St. Cutting Oil)1.jpeg",
    desc: "Used for MS drawing (Shallow, Deep & EDD) is manufactured with a consideration to prevent seizure of the parts & reduce friction during the drawing process. Easily washable with any metal cleaner & economical in use.",

    whatsappText: "Hello, I want details about FINE DRAW MS",
  },
  {
    id: 48,
    category: "Drawing Oils. Punching Oils. Rolling Oil",
    categorySlug: "drawing-oils-punching-oils-rolling-oil",
    navText: "Punching Oils. Rolling Oil",
    slug: "fine-draw-ss",
    title: "FINE DRAW SS",
    img: "/assets/img/products_image/Fine Kut (St. Cutting Oil)1.jpeg",
    desc: "Used for SS drawing (Shallow, Deep & EDD). It is a higher viscosity oil containing EP additives. It is 99% soluble in water making it cost effective for end user. It is non-hazardous & non-toxic oil containin high extreme pressure value. Easily washable with any metal cleaner.",

    whatsappText: "Hello, I want details about FINE DRAW SS",
  },
  {
    id: 49,
    category: " Drawing Oils. Punching Oils. Rolling Oil",
    categorySlug: "drawing-oils-punching-oils-rolling-oil",
    navText: "Punching Oils. Rolling Oil",
    slug: "fine-draw-al",
    title: "FINE DRAW AL",
    img: "/assets/img/products_image/Fine Kut (St. Cutting Oil)1.jpeg",
    desc: "It is a cost-effective oil used for Aluminum drawing. Contains EP additives to ensure a smooth draw.",

    whatsappText: "Hello, I want details about FINE DRAW AL",
  },
  {
    id: 50,
    category: "Drawing Oils. Punching Oils. Rolling Oil",
    categorySlug: "drawing-oils-punching-oils-rolling-oil",
    navText: "Punching Oils. Rolling Oil",
    slug: "meta-form-rn-180-rn-200",
    title: "META FORM RN- 180 & RN-200",
    img: "/assets/img/products_image/Fine Kut (St. Cutting Oil)1.jpeg",
    desc: "Water Washable Metal forming Oil & Drawing Fluid The product is designed for easy metal forming & metal drawing operations with excellent finish, total prevention of seizer of moving parts. The product has high EP value. Meta form RN-200 is unlike others; the oil film is easily washable with water. The work place remains clean all the time. The product has excellent oxidation stability, lubrication and anti anti-wear qualities along with anti-rusting properties. The laborious washing operation with hazardous Kerosene or solvents is totally reduced. Meta form-RN-200 is most economical and useful useful fo for operations like wire drawing, deep drawing, cold extrusion & cab body drawing operations with all ferrous & alloy steel & plated materials. It can be applied with brush or spray method.",

    whatsappText: "Hello, I want details about META FORM RN- 180 & RN-200",
  },
  // Automotive Oils
  {
    id: 51,
    category: "Automotive Oils",
    categorySlug: "automotive-oils",
    navText: "Automotive Oils",
    slug: "fine-gear-ep-90",
    title: "FINE GEAR EP 90",
    img: "/assets/img/products_image/Automotive_oil/Automotive_oil.jpeg",
    desc: "Fine Gear EP 90 is a premium extreme pressure gear oil formulated to provide superior lubrication and wear protection for automotive and industrial gear systems. Its high loadcarrying capacity and thermal stability ensure smooth performance, reduced noise, and extended gear life under demanding operating conditions.",

    whatsappText: "Hello, I want details about FINE GEAR EP 90",
  },
  {
    id: 52,
    category: "Automotive Oils",
    categorySlug: "automotive-oils",
    navText: "Automotive Oils",
    slug: "fine-gear-ep-140",
    title: "FINE GEAR EP 140",
    img: "/assets/img/products_image/Automotive_oil/Automotive_oil.jpeg",
    desc: "Fine Gear EP 140 is a premium extreme pressure gear oil designed for heavy-duty gear systems. It provides excellent load-carrying capacity, superior wear protecttion, and resistance to oxidation, ensuring smooth operation and extended gear rrying life even under high temperature and shock-loading conditions.",

    whatsappText: "Hello, I want details about FINE GEAR EP 140",
  },
  {
    id: 53,
    category: "Automotive Oils",
    categorySlug: "automotive-oils",
    navText: "Automotive Oils",
    slug: "fine-gear-75w90",
    title: "FINE GEAR 75W90",
    img: "/assets/img/products_image/Automotive_oil/Automotive_oil.jpeg",
    desc: "Gear Oil 75W90 is a high-performance, fully synthetic gear lubricant designed d to to deliver de outstanding ding protection and smooth operation in a wide range of temperatures. Formulated with premium synthetic base oils and advanced extreme pressure (EP) additives, it ensures excellent gear protection under high load and shock-loading conditions. This oil meets or exceeds API GL-5 and MT-1 specifications and is suitable for use in a wide variety of automotive and heavy-duty manual transmissions, axles, and differentials, including those with limited slip.",

    whatsappText: "Hello, I want details about FINE GEAR 75W90",
  },
  {
    id: 54,
    category: "Automotive Oils",
    categorySlug: "automotive-oils",
    navText: "Automotive Oils",
    slug: "fine-gear-80w90",
    title: "FINE GEAR 80W90",
    img: "/assets/img/products_image/Automotive_oil/Automotive_oil.jpeg",
    desc: "Is a multi grade gear oil bended with carefully selected virgin base stocks, anti corrosive, anti foaming, extreme pressure additives. They are mostly used in commercial heavy vehicles, passenger cars, construction mining and agricultural industries. Performance Level - API GL 4.",

    whatsappText: "Hello, I want details about FINE GEAR 80W90",
  },
  {
    id: 55,
    category: "Automotive Oils",
    categorySlug: "automotive-oils",
    navText: "Automotive Oils",
    slug: "fine-gear-80w140",
    title: "FINE GEAR 80W140",
    img: "/assets/img/products_image/Automotive_oil/Automotive_oil.jpeg",
    desc: "Is a multi grade gear oil bended with carefully selected virgin base stocks, anti corrosive, anti foaming, extreme pressure additives. They are mostly used in commercial heavy vehicles, passenger cars, construction mining and agricultural industries. Performance Level - API GL 4.",

    whatsappText: "Hello, I want details about FINE GEAR 80W140",
  },
  {
    id: 56,
    category: "Automotive Oils",
    categorySlug: "automotive-oils",
    navText: "Automotive Oils",
    slug: "fine-gear-85w140",
    title: "FINE GEAR 85W140",
    img: "/assets/img/products_image/Automotive_oil/Automotive_oil.jpeg",
    desc: "Gear Oil 85W140 is a premium-grade, heavy-duty gear lubricant formulated with high-quality base oils and advanced extreme pressure (EP) additives. It provides excellent protection and performance in severe operating conditions, including high loads, shock loading, and wide temperature variations. This oil meets the requirements of API GL-5 and is designed for use in hypoid gear differentials, manual transmissions, and other heavy-duty gear systems found in commercial vehicles, off-road machinery, and industrial applications.",

    whatsappText: "Hello, I want details about FINE GEAR 85W140",
  },
  {
    id: 57,
    category: "Automotive Oils",
    categorySlug: "automotive-oils",
    navText: "Automotive Oils",
    slug: "atf",
    title: "ATF (Fine Transmission Oil)",
    img: "/assets/img/products_image/Automotive_oil/Automotive_oil.jpeg",
    desc: "It is used to lubricate the entire drive train in modern day automatic transmission systems. It is also recommended for gear boxes, power steering's & hydraulic systems.",

    whatsappText: "Hello, I want details about ATF",
  },
  {
    id: 58,
    category: "Automotive Oils",
    categorySlug: "automotive-oils",
    navText: "Automotive Oils",
    slug: "fine-cool",
    title: "FINE COOL (Anti-Freeze Radiator Coolant) ",
    img: "/assets/img/products_image/Automotive_oil/Automotive_oil.jpeg",
    desc: "It is a synthetic base coolant, free from amines, borates, silicates & phosphates etc. They have high boiling points & low freezing points for extreme weather conditions.",

    whatsappText:
      "Hello, I want details about FINE COOL (Anti-Freeze Radiator Coolant)",
  },
  {
    id: 59,
    category: "Automotive Oils",
    categorySlug: "automotive-oils",
    navText: "Automotive Oils",
    slug: "fine-brake-utto",
    title: "FINE BRAKE UTTO (Wet brake Oil)",
    img: "/assets/img/products_image/Automotive_oil/Automotive_oil.jpeg",
    desc: "This is a premium grade transmission oil blended from hydrotreated base stocks for lubrication of Wet brake systems, hydraulic systems, gear systems of agricultural vehicles.",

    whatsappText: "Hello, I want details about FINE Brake Utto (Wet brake Oil)",
  },
  // Engine Oils
  {
    id: 60,
    category: "Engine Oils",
    categorySlug: "engine-oils",
    navText: "Engine Oils",
    slug: "fine-ride-5w30",
    title: "FINE RIDE 5W30",
    img: "/assets/img/products_image/Engine_Oil/Engine_Oil.jpg",
    desc: "This is a synthetic engine advanced vehicles. They are made from high viscosity index base stocks. Viscosity of the oil is maintained in both winter & summer conditions due to the use of premium synthetic base stock.",

    whatsappText: "Hello, I want details about FINE RIDE 5W30",

    variants: ["20 L", "26 L", "50 L", "210 L"],
  },
  {
    id: 61,
    category: "Engine Oils",
    categorySlug: "engine-oils",
    navText: "Engine Oils",
    slug: "fine-ride-10w30",
    title: "FINE RIDE 10W30",
    img: "/assets/img/products_image/Engine_Oil/Engine_Oil1.jpg",
    desc: "This engine oil is specially designed to give optimum performance in new generation scooters /mopeds, automatic gear shift scooters.",

    whatsappText: "Hello, I want details about FINE RIDE 10W30",

    variants: ["20 L", "26 L", "50 L", "210 L"],
  },
  {
    id: 62,
    category: "Engine Oils",
    categorySlug: "engine-oils",
    navText: "Engine Oils",
    slug: "fine-drive-15w40",
    title: "FINE DRIVE 15W40",
    img: "/assets/img/products_image/Engine_Oil/Engine_Oil2.jpg",
    desc: "This engine oil is designed for heavy duty commercial diesel vehicles to give maximum output in kilometers. The blend is venicles to give ma fortified with group 2 base oils and high additive content so as to give maximum smoothness and efficiency on freeways.",

    whatsappText: "Hello, I want details about FINE DRIVE 15W40",

    variants: ["20 L", "26 L", "50 L", "210 L"],
  },
  {
    id: 63,
    category: "Engine Oils",
    categorySlug: "engine-oils",
    navText: "Engine Oils",
    slug: "fine-drive-15w50",
    title: "FINE DRIVE 15W50",
    img: "/assets/img/products_image/Engine_Oil/Engine_Oil3.jpg",
    desc: "This engine oil is designed specially to meet the requirements of modern age heavy duty motorbikes. Improves overall engine performance and offers a full range temperature protection from cold starts to high temperatures.",

    whatsappText: "Hello, I want details about FINE DRIVE 15W50",

    variants: ["20 L", "26 L", "50 L", "210 L"],
  },
  {
    id: 64,
    category: "Engine Oils",
    categorySlug: "engine-oils",
    navText: "Engine Oils",
    slug: "fine-ride-20w40",
    title: "FINE RIDE 20W40",
    img: "/assets/img/products_image/Engine_Oil/Engine_Oil4.jpg",
    desc: "A multi grade engine oil and one of the most robust engine oil blends designed to work in most extreme conditions. They can be used in new generation 4 stroke bikes as well as passenger cars.",

    whatsappText: "Hello, I want details about FINE RIDE 20W40",
    variants: ["20 L", "26 L", "50 L", "210 L"],
  },
  {
    id: 65,
    category: "Engine Oils",
    categorySlug: "engine-oils",
    navText: "Engine Oils",
    slug: "fine-ride-20w50",
    title: "FINE DRIVE 20W50",
    img: "/assets/img/products_image/Engine_Oil/Engine_Oil5.jpg",
    desc: "Is a multi grade engine oil, being slightly more viscous than 20W40 and with a better additive pack is now a days being used in most of modern gasoline and diesel engines. The performance is better at higher temperatures and has ner temperature better load bearing capabilities. This oil prevents engine sludge formation on the engine pistons and excellent anti-wear protection.",

    whatsappText: "Hello, I want details about FINE RIDE 20W50",
    variants: ["20 L", "26 L", "50 L", "210 L"],
  },
  // Construction Chemicals
  {
    id: 66,
    category: "Construction Chemicals",
    categorySlug: "construction-chemicals",
    navText: "Construction Chemicals",
    slug: "shuttering-oil-water-base",
    title: "SHUTTERING OIL (WATER BASE)",
    img: "/assets/img/products_image/Construction_Chemicals/Shuttering_oil.jpg",
    desc: "Shuttering Oil (Water Base) is a specially formulated, ready-to-use concrete mould release agent designed for application on shuttering and formwork surfaces. It creates a thin, stable film that prevents the adhesion of fresh concrete to moulds, ensuring smooth, stain-free, and high-quality concrete surfaces. This eco-friendly, water-dilutable emulsion is non-toxic, nonhazardous, and safe for both steel and wooden formworks. It minimizes surface blemishes, reduces cleaning time, and extends the life of shuttering material.",

    whatsappText: "Hello, I want details about SHUTTERING OIL (WATER BASE)",
  },
  {
    id: 67,
    category: "Construction Chemicals",
    categorySlug: "construction-chemicals",
    navText: "Construction Chemicals",
    slug: "shuttering-oil-oil-base",
    title: "Shuttering Oil (Oil Base)",
    img: "/assets/img/products_image/Construction_Chemicals/Shuttering_oil.jpg",
    desc: "Shuttering Oil (Water Base) is a specially formulated, ready-to-use concrete mould release agent designed for application on shuttering and formwork surfaces. It creates a thin, stable film that prevents the adhesion of fresh concrete to moulds, ensuring smooth, stain-free, and high-quality concrete surfaces. This eco-friendly, water-dilutable emulsion is non-toxic, nonhazardous, and safe for both steel and wooden formworks. It minimizes surface blemishes, reduces cleaning time, and extends the life of shuttering material.",

    whatsappText: "Hello, I want details about SHUTTERING OIL (WATER BASE)",
  },
  {
    id: 68,
    category: "Construction Chemicals",
    categorySlug: "construction-chemicals",
    navText: "Construction Chemicals",
    slug: "mivan-grease-shuttering-grease",
    title: "MIVAN Grease (Shuttering Grease)",
    img: "/assets/img/products_image/Construction_Chemicals/Mivan_Grease.jpeg",
    desc: "MIVAN Grease is a heavy-duty mould release compound specially formulated for use on shuttering, formwork, and mould surfaces in concrete construction. Unlike conventional shuttering oils, this greasebased release agent provides a long-lasting lubricating and protective film, ensuring easy stripping of formwork and producing a smooth, uniform concrete finish. It is designed for vertical and horizontal shuttering applications also used for wooden & aluminium Frame work where superior adhesion, longer lasting protection, and extended reuse of formwork are required.",

    whatsappText: "Hello, I want details about SHUTTERING OIL (WATER BASE)",
  },
];
